import styled from 'styled-components/macro'
import Box from 'components/shared/Box'

import { respondAbove } from 'styles/mediaQueries'

export const NotFoundWrapper = styled(Box)`
    max-width: 1200px;
    margin: auto;

    img {
        max-height: 100px;
        max-width: 217px;
    }

    > div:first-of-type {
        max-width: 670px;
    }

    @media ${respondAbove.xl} {
        img {
            max-width: unset;
            width: 312px;
        }
    }
`
